import { styled } from "@mui/material";

export const Wrapper = styled("div")`
	width: 1200px;
`;

export const InfoWrapper = styled("div")`
	max-width: 400px;
`;
